import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Container, Typography } from '@material-ui/core'
import { createGlobalStyle } from 'styled-components'
import img2 from '../assets/Smarctic2.jpg'
import img4 from '../assets/cold.png'
import FadeIn from 'react-fade-in/lib/FadeIn'

const GlobalStyle = createGlobalStyle`
  body {
    background: url(${img2}) no-repeat;
    background-color: #000000;
    background-attachment: fixed;
    margin-bottom: 100px;
    background-size: 100%;
  }
`


const Ounashalli = () => (
  <FadeIn transitionDuration="3000">
    <Container>
      <React.Fragment>
        <GlobalStyle  />
      </React.Fragment>
      <Typography variant="h3" style={{ color:'white' }}>Pilot Site Ounashalli</Typography>
      <div style={{ marginLeft:'40%' }}>
        <div className="Pilot-areas">
          Facts
          <Typography variant="subtitle1">Builded: 1986<br></br>Size: 62,7 m x 98,9 m = 6190 m²<br></br> Height: 13,5 m<br></br>Volume: 59 400 m³<br></br>Heating system: District heating<br></br>Heat distribution: Ventilation<br></br>Time of use: 08:00 – 23:00</Typography>
          <br></br>Installed sensors
          <Typography variant="subtitle1">MCF88 MCF-LW12VOC<br></br>LoRaWAN indoor environmental sensor including measurement of VOC and LUX<br></br>Ruuvitag<br></br>Bluetooth sensor for outside temperature, air humidity, air pressure and motion<br></br>Pycom development board with LoPy 4.0 and Pycom Expansion Board<br></br>Development board for Bluetooth and LoRa connections. This board also includes LoRa Antenna </Typography>
          <br></br>What we learn?
          <Typography variant="subtitle1">Lighting consumes 74% of the property&apos;s electricity. We found out by the luminance sensors that lights are on over 240 hours without a reason in the hall. This unnecessary consumption costs more than 500 euros a year. Old gas discharge lamps should and will be replaced by modern LED lightning, it will reduce electricity consumption by 37-52% in a year in the property. We can see from the indoor temperature data that in very cold days, indoor temperature could drop all the way to +6 degrees. Indoor temperature is set to be + 12 degree. New ventilation machine will be installed.</Typography>
          <br></br>
          <img src={img4} width='100%'></img>
          <Button
            component={Link}
            to="/Pilot-sites/Ounashalli"
            style={{
              fontSize:'35px',
              color: 'white',
              background:'black',
              minWidth:'450px',
              border:'1px solid white',
              margin:'1%'
            }}>Sensor data</Button>
        </div>
      </div>
    </Container>
  </FadeIn>
)

export default Ounashalli